import isEmpty from 'lodash/isEmpty';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export function getSalesCoverageNames(
  salesCoverage: InvestorFirmFragment['salesCoverage']
): string[] {
  return (salesCoverage?.items ?? [])
    .map(({ employeeName }) => employeeName)
    .filter((name): name is string => !isEmpty(name));
}
